export enum TabValue {
  OVERVIEW = 'overview',
  RESOURCES = 'resources',
}
